// src/components/Archive.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getArchivedSeasons } from '../services/api';
import Avatar from './Avatar';
import '../App.css';
import pointsIcon from '../assets/points_icon.png';

export default function Archive() {
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getArchivedSeasons()
      .then(res => setSeasons(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="loading-screen">Загрузка архива...</div>;
  }

  return (
    <div className="archive-container">
      <Link to="/" className="back-link">&larr; Назад на главную</Link>
      <h1>Архив сезонов</h1>
      {seasons.length === 0 ? (
        <p>Пока нет ни одного завершенного сезона.</p>
      ) : (
        <div className="seasons-grid">
          {seasons.map(season => (
            <div key={season.id} className="season-archive-card card">
              <h3>{season.name}</h3>
              <p className="season-dates">
                {new Date(season.startDate).toLocaleDateString()} - {new Date(season.endDate).toLocaleDateString()}
              </p>
              <h2>Победитель сезона: {season.winnerData?.top5[0]?.username}</h2>
              <h4>Топ-5 сезона:</h4>
              <ol className="winners-list">
                {season.winnerData?.top5?.map((winner, index) => (
                  <li key={winner.userId} className="winner-item">
                    <span className="winner-rank">#{index + 1}</span>
                    <Avatar
                      user={{ id: winner.userId, username: winner.username, avatar: winner.avatar, serverNickname: winner.serverNickname }}
                      className="winner-avatar"
                    />
                    <span className="winner-name">{winner.username}</span>
                    <span className="winner-points">{winner.totalPoints} <img src={pointsIcon} alt="points" className="points-icon seasonal-icon" /></span>
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}